import React from 'react';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { css } from '@emotion/react';
import theme from '@styles/theme';
import WarningPopupContainer from '@components/commons/popup/container/WarningPopupContainer';

interface INoticeWholePurchaseInfoPopup {
  isShow: boolean;
  storyId?: number;
  onClose: () => void;
}

const NoticeWholePurchaseInfoPopup = ({
  isShow,
  storyId = 0,
  onClose,
}: INoticeWholePurchaseInfoPopup) => {
  const { t } = useTranslation();
  const router = useRouter();

  const handleContinueInAppButtonClick = async () => {
    await router.push({
      pathname: '/auth',
      query: {
        url: `/story/${storyId}`,
      },
    });
    onClose();
  };

  if (!isShow) {
    return null;
  }

  return (
    <WarningPopupContainer title={t('login_screen_label_login')}>
      <div css={container}>
        <div className="content"></div>
        <button className="app-button" onClick={handleContinueInAppButtonClick}>
          {t('common_screen_title_login')}
        </button>
        <button className="web-button" onClick={onClose}>
          {t('common_popup_button_return_to_details')}
        </button>
      </div>
    </WarningPopupContainer>
  );
};

const container = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Apple SD Gothic Neo';

  .content {
    width: 18.75rem;
  }

  .app-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1.5em;
    width: 100%;
    height: 3.25em;
    cursor: pointer;
    background-color: ${theme.colors.primary500};
    color: ${theme.colors.white};
    font-weight: 700;
    line-height: 1.375em;
    border-radius: 0.5em;
    font-size: 1em;
  }

  .web-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1em;
    font-weight: 400;
    width: 100%;
    font-size: 0.875em;
    color: ${theme.colors.primary500};
    line-height: 1.375em;
    cursor: pointer;
  }
`;

export default NoticeWholePurchaseInfoPopup;
